import { Component, Inject, OnInit } from '@angular/core';
import { CustomDialogOptions } from '@fb-tool-front/shared/components/dialog/dialog.component';
import { TuiDialog } from '@taiga-ui/cdk';
import { POLYMORPHEUS_CONTEXT } from '@tinkoff/ng-polymorpheus';
import { LocaleService } from '@fb-tool-front/core/services/locale.service';
import { LOCALES } from '@fb-tool-front/shared/constants/locale.constant';
import { environment } from '@fb-tool-front/environments/environment';

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss']
})
export class VideoPlayerComponent implements OnInit {
  youtubeTutorVideo =
    this.localeService.locale === LOCALES.ru
      ? environment.youtubeTutorVideoRu
      : environment.youtubeTutorVideoEn;
  videoUrl: string;

  constructor(
    @Inject(POLYMORPHEUS_CONTEXT) readonly context: TuiDialog<CustomDialogOptions<any>, any>,
    private localeService: LocaleService
  ) {}

  ngOnInit() {
    this.videoUrl = this.context.data?.videoUrl;
  }

  public close(result: any = null) {
    this.context.completeWith(result);
  }
}
